import { Link } from "react-router-dom";
import { Logo } from "@/components/base";
import ThemeToggle from "@/components/ThemeToggle";
import { useAuth } from "@/lib/auth";
import { openCookies } from "@/lib/consent";

export function PublicHeader({ onLogin }) {
  const { user } = useAuth();
  return (
    <header className="safe-top relative z-20">
      <div className="mx-auto flex h-14 max-w-[1120px] items-center justify-between px-5 sm:h-16 sm:px-8">
        <Logo />
        <div className="flex items-center gap-1">
          <ThemeToggle />
          {user ? (
            <Link to="/app" data-testid="open-app-link" className="rounded-full px-3.5 py-2 text-[14px] font-medium text-ink hover:bg-surface-2">
              Mon espace
            </Link>
          ) : (
            <button type="button" onClick={onLogin} data-testid="login-link" className="rounded-full px-3.5 py-2 text-[14px] font-medium text-ink hover:bg-surface-2">
              Se connecter
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export function PublicFooter({ compact = false }) {
  return (
    <footer className={`relative z-10 ${compact ? "" : "border-t border-line"}`} data-cta-guard="">
      <div
        className={`relative z-10 mx-auto flex max-w-[1120px] gap-3 px-5 text-[13px] text-muted sm:items-center sm:justify-between sm:px-8 ${
          compact ? "min-h-12 flex-row flex-wrap items-center justify-between gap-y-1 py-3" : "flex-col py-8 sm:flex-row"
        }`}
      >
        <span className="font-semibold lowercase tracking-[-0.02em] text-ink">archijo</span>
        <span className="flex min-w-0 flex-wrap gap-x-5 gap-y-2">
          <Link to="/confidentialite" data-testid="privacy-link" className="hover:text-ink">
            Politique de confidentialité
          </Link>
          <Link to="/mentions-legales" data-testid="legal-link" className="hover:text-ink">
            Mentions légales
          </Link>
          <Link to="/conditions" data-testid="conditions-link" className="hover:text-ink">
            Conditions d'utilisation
          </Link>
          <button type="button" onClick={openCookies} data-testid="cookies-link" className="hover:text-ink">
            Cookies
          </button>
        </span>
      </div>
    </footer>
  );
}
